/**
 * Diccionario Interactivo Completo para Motor Pedagógico IE EOH
 * Búsqueda instantánea de traducción y pronunciación en español.
 */

const DICTIONARY_MAP = {
  // Pronombres y Posesivos
  "i": { trans: "Yo", pos: "Pronombre" },
  "you": { trans: "Tú / Usted / Ustedes", pos: "Pronombre" },
  "he": { trans: "Él", pos: "Pronombre" },
  "she": { trans: "Ella", pos: "Pronombre" },
  "it": { trans: "Eso / Ello (objeto/animal)", pos: "Pronombre" },
  "we": { trans: "Nosotros / Nosotras", pos: "Pronombre" },
  "they": { trans: "Ellos / Ellas", pos: "Pronombre" },
  "my": { trans: "Mi / Mis", pos: "Posesivo" },
  "your": { trans: "Tu / Tus / Su (de ustedes)", pos: "Posesivo" },
  "his": { trans: "Su (de él)", pos: "Posesivo" },
  "her": { trans: "Su (de ella)", pos: "Posesivo" },
  "our": { trans: "Nuestro / Nuestra", pos: "Posesivo" },
  "their": { trans: "Su (de ellos)", pos: "Posesivo" },
  "this": { trans: "Este / Esta", pos: "Demostrativo" },
  "that": { trans: "Ese / Esa / Aquel", pos: "Demostrativo" },
  "these": { trans: "Estos / Estas", pos: "Demostrativo" },
  "those": { trans: "Esos / Esas / Aquellos", pos: "Demostrativo" },

  // Verbos Comunes y Auxiliares
  "be": { trans: "Ser o Estar", pos: "Verbo" },
  "am": { trans: "Soy / Estoy (con I)", pos: "Verbo To Be" },
  "is": { trans: "Es / Está (con he/she/it)", pos: "Verbo To Be" },
  "are": { trans: "Son / Están / Eres / Estás", pos: "Verbo To Be" },
  "was": { trans: "Era / Estaba (pasado de am/is)", pos: "Verbo Pasado" },
  "were": { trans: "Eran / Estaban (pasado de are)", pos: "Verbo Pasado" },
  "do": { trans: "Hacer / Auxiliar del presente", pos: "Verbo Auxiliar" },
  "does": { trans: "Hace (tercera persona)", pos: "Verbo Auxiliar" },
  "did": { trans: "Hizo / Auxiliar del pasado", pos: "Verbo Auxiliar" },
  "have": { trans: "Tener / Haber", pos: "Verbo" },
  "has": { trans: "Tiene (tercera persona)", pos: "Verbo" },
  "had": { trans: "Tenía / Tuvo", pos: "Verbo Pasado" },
  "go": { trans: "Ir", pos: "Verbo" },
  "goes": { trans: "Va", pos: "Verbo" },
  "went": { trans: "Fue / Iba (pasado de go)", pos: "Verbo Pasado" },
  "get": { trans: "Obtener / Conseguir / Llegar", pos: "Verbo" },
  "gets": { trans: "Obtiene / Llega", pos: "Verbo" },
  "wake": { trans: "Despertarse", pos: "Verbo" },
  "brush": { trans: "Cepillarse / Cepillo", pos: "Verbo / Sustantivo" },
  "eat": { trans: "Comer", pos: "Verbo" },
  "drink": { trans: "Beber / Bebida", pos: "Verbo / Sustantivo" },
  "study": { trans: "Estudiar", pos: "Verbo" },
  "studies": { trans: "Estudia", pos: "Verbo" },
  "write": { trans: "Escribir", pos: "Verbo" },
  "read": { trans: "Leer", pos: "Verbo" },
  "listen": { trans: "Escuchar", pos: "Verbo" },
  "speak": { trans: "Hablar", pos: "Verbo" },
  "learn": { trans: "Aprender", pos: "Verbo" },
  "can": { trans: "Poder (Habilidad / Permiso)", pos: "Verbo Modal" },
  "cannot": { trans: "No poder", pos: "Verbo Modal" },
  "can't": { trans: "No poder (abreviado)", pos: "Verbo Modal" },
  "must": { trans: "Deber / Obligación estricta", pos: "Verbo Modal" },
  "should": { trans: "Debería (Consejo)", pos: "Verbo Modal" },
  "will": { trans: "Auxiliar de Futuro (Hará/Haré)", pos: "Verbo Modal" },
  "would": { trans: "Haría (Condicional)", pos: "Verbo Modal" },
  "work": { trans: "Trabajar / Trabajo", pos: "Verbo / Sustantivo" },
  "live": { trans: "Vivir", pos: "Verbo" },
  "play": { trans: "Jugar / Tocar instrumento", pos: "Verbo" },
  "run": { trans: "Correr", pos: "Verbo" },
  "see": { trans: "Ver", pos: "Verbo" },
  "look": { trans: "Mirar", pos: "Verbo" },
  "think": { trans: "Pensar", pos: "Verbo" },
  "know": { trans: "Saber / Conocer", pos: "Verbo" },
  "make": { trans: "Hacer / Crear", pos: "Verbo" },
  "take": { trans: "Tomar / Llevar", pos: "Verbo" },
  "come": { trans: "Venir", pos: "Verbo" },
  "help": { trans: "Ayudar / Ayuda", pos: "Verbo / Sustantivo" },
  "like": { trans: "Gustar / Como (semejanza)", pos: "Verbo / Preposición" },
  "prefer": { trans: "Preferir", pos: "Verbo" },

  // Palabras de Pregunta (Wh- Words)
  "what": { trans: "Qué / Cuál", pos: "Pregunta" },
  "where": { trans: "Dónde", pos: "Pregunta" },
  "when": { trans: "Cuándo", pos: "Pregunta" },
  "who": { trans: "Quién / Quiénes", pos: "Pregunta" },
  "why": { trans: "Por qué", pos: "Pregunta" },
  "how": { trans: "Cómo / Cuánto", pos: "Pregunta" },
  "which": { trans: "Cuál / Cuáles (entre opciones)", pos: "Pregunta" },
  "whose": { trans: "De quién", pos: "Pregunta" },

  // Conectores y Preposiciones
  "and": { trans: "Y", pos: "Conector" },
  "or": { trans: "O", pos: "Conector" },
  "but": { trans: "Pero / Sin embargo", pos: "Conector" },
  "because": { trans: "Porque (razón)", pos: "Conector" },
  "in": { trans: "En / Dentro de", pos: "Preposición" },
  "on": { trans: "En / Sobre", pos: "Preposición" },
  "at": { trans: "En (lugar específico / hora)", pos: "Preposición" },
  "to": { trans: "A / Hacia / Para", pos: "Preposición" },
  "for": { trans: "Para / Por", pos: "Preposición" },
  "with": { trans: "Con", pos: "Preposición" },
  "without": { trans: "Sin", pos: "Preposición" },
  "about": { trans: "Acerca de / Sobre", pos: "Preposición" },
  "from": { trans: "De / Desde", pos: "Preposición" },
  "under": { trans: "Debajo de", pos: "Preposición" },
  "next": { trans: "Siguiente / Al lado de (next to)", pos: "Preposición" },
  "between": { trans: "Entre dos cosas", pos: "Preposición" },
  "after": { trans: "Después de", pos: "Preposición" },
  "before": { trans: "Antes de", pos: "Preposición" },
  "during": { trans: "Durante", pos: "Preposición" },

  // Sustantivos Comunes y Escolares
  "student": { trans: "Estudiante / Alumno", pos: "Sustantivo" },
  "students": { trans: "Estudiantes / Alumnos", pos: "Sustantivo" },
  "teacher": { trans: "Profesor / Profesora", pos: "Sustantivo" },
  "school": { trans: "Colegio / Escuela", pos: "Sustantivo" },
  "class": { trans: "Clase / Salón", pos: "Sustantivo" },
  "classroom": { trans: "Salón de clase", pos: "Sustantivo" },
  "book": { trans: "Libro", pos: "Sustantivo" },
  "notebook": { trans: "Cuaderno", pos: "Sustantivo" },
  "family": { trans: "Familia", pos: "Sustantivo" },
  "mother": { trans: "Madre / Mamá", pos: "Sustantivo" },
  "father": { trans: "Padre / Papá", pos: "Sustantivo" },
  "brother": { trans: "Hermano", pos: "Sustantivo" },
  "sister": { trans: "Hermana", pos: "Sustantivo" },
  "grandmother": { trans: "Abuela", pos: "Sustantivo" },
  "grandfather": { trans: "Abuelo", pos: "Sustantivo" },
  "house": { trans: "Casa", pos: "Sustantivo" },
  "home": { trans: "Hogar", pos: "Sustantivo" },
  "room": { trans: "Habitación / Cuarto", pos: "Sustantivo" },
  "bedroom": { trans: "Dormitorio", pos: "Sustantivo" },
  "kitchen": { trans: "Cocina", pos: "Sustantivo" },
  "bathroom": { trans: "Baño", pos: "Sustantivo" },
  "living": { trans: "Sala de estar (living room)", pos: "Sustantivo" },
  "city": { trans: "Ciudad", pos: "Sustantivo" },
  "street": { trans: "Calle", pos: "Sustantivo" },
  "park": { trans: "Parque", pos: "Sustantivo" },
  "time": { trans: "Tiempo / Hora", pos: "Sustantivo" },
  "day": { trans: "Día", pos: "Sustantivo" },
  "morning": { trans: "Mañana (inicio del día)", pos: "Sustantivo" },
  "afternoon": { trans: "Tarde", pos: "Sustantivo" },
  "night": { trans: "Noche", pos: "Sustantivo" },
  "food": { trans: "Comida / Alimento", pos: "Sustantivo" },
  "water": { trans: "Agua", pos: "Sustantivo" },
  "breakfast": { trans: "Desayuno", pos: "Sustantivo" },
  "lunch": { trans: "Almuerzo", pos: "Sustantivo" },
  "dinner": { trans: "Cena", pos: "Sustantivo" },
  "question": { trans: "Pregunta", pos: "Sustantivo" },
  "questions": { trans: "Preguntas", pos: "Sustantivo" },
  "answer": { trans: "Respuesta / Responder", pos: "Sustantivo / Verbo" },
  "sentence": { trans: "Oración / Frase", pos: "Sustantivo" },
  "text": { trans: "Texto / Lectura", pos: "Sustantivo" },
  "word": { trans: "Palabra", pos: "Sustantivo" },
  "words": { trans: "Palabras", pos: "Sustantivo" },
  "meaning": { trans: "Significado", pos: "Sustantivo" },
  "topic": { trans: "Tema / Asunto", pos: "Sustantivo" },
  "option": { trans: "Opción", pos: "Sustantivo" },

  // Adjetivos Comunes
  "good": { trans: "Bueno / Buen", pos: "Adjetivo" },
  "bad": { trans: "Malo / Deficiente", pos: "Adjetivo" },
  "happy": { trans: "Feliz / Alegre", pos: "Adjetivo" },
  "sad": { trans: "Triste", pos: "Adjetivo" },
  "big": { trans: "Grande", pos: "Adjetivo" },
  "small": { trans: "Pequeño", pos: "Adjetivo" },
  "fast": { trans: "Rápido", pos: "Adjetivo" },
  "slow": { trans: "Lento", pos: "Adjetivo" },
  "new": { trans: "Nuevo", pos: "Adjetivo" },
  "old": { trans: "Viejo / Antiguo / Años de edad", pos: "Adjetivo" },
  "important": { trans: "Importante", pos: "Adjetivo" },
  "favorite": { trans: "Favorito / Preferido", pos: "Adjetivo" },
  "correct": { trans: "Correcto / Adecuado", pos: "Adjetivo" },
  "incorrect": { trans: "Incorrecto", pos: "Adjetivo" },
  "true": { trans: "Verdadero", pos: "Adjetivo" },
  "false": { trans: "Falso", pos: "Adjetivo" },
  "daily": { trans: "Diario / Cotidiano", pos: "Adjetivo" },
  "easy": { trans: "Fácil", pos: "Adjetivo" },
  "hard": { trans: "Difícil / Duro", pos: "Adjetivo" },

  // Adverbios
  "always": { trans: "Siempre", pos: "Adverbio" },
  "never": { trans: "Nunca / Jamás", pos: "Adverbio" },
  "sometimes": { trans: "A veces / En ocasiones", pos: "Adverbio" },
  "usually": { trans: "Usualmente / Por lo general", pos: "Adverbio" },
  "often": { trans: "A menudo / Frecuentemente", pos: "Adverbio" },
  "every": { trans: "Cada / Todos los", pos: "Adjetivo / Adverbio" },
  "today": { trans: "Hoy", pos: "Adverbio" },
  "tomorrow": { trans: "Mañana (día siguiente)", pos: "Adverbio" },
  "yesterday": { trans: "Ayer", pos: "Adverbio" },
  "not": { trans: "No (negación)", pos: "Adverbio" },
  "very": { trans: "Muy / Mucho", pos: "Adverbio" },
  "more": { trans: "Más", pos: "Adverbio" },
  "most": { trans: "El más / La mayoría", pos: "Adverbio" }
};

/**
 * Busca el significado de una palabra en inglés
 */
export async function getSpanishMeaning(rawWord) {
  if (!rawWord) return null;
  const cleanWord = rawWord.toLowerCase().replace(/[^a-z']/g, '').trim();
  if (!cleanWord) return null;

  // 1. Buscar en diccionario interno directo
  if (DICTIONARY_MAP[cleanWord]) {
    return {
      word: rawWord.replace(/[^a-zA-Z']/g, ''),
      cleanWord,
      trans: DICTIONARY_MAP[cleanWord].trans,
      pos: DICTIONARY_MAP[cleanWord].pos
    };
  }

  // 2. Si termina en 's' o 'es', intentar buscar singular
  if (cleanWord.endsWith('s') && cleanWord.length > 2) {
    const singular = cleanWord.replace(/es$/, '').replace(/s$/, '');
    if (DICTIONARY_MAP[singular]) {
      return {
        word: rawWord.replace(/[^a-zA-Z']/g, ''),
        cleanWord: singular,
        trans: DICTIONARY_MAP[singular].trans,
        pos: DICTIONARY_MAP[singular].pos
      };
    }
  }

  // 3. Si termina en 'ing' (gerundio), buscar el verbo base
  if (cleanWord.endsWith('ing') && cleanWord.length > 4) {
    const baseVerb = cleanWord.replace(/ing$/, '');
    if (DICTIONARY_MAP[baseVerb]) {
      return {
        word: rawWord.replace(/[^a-zA-Z']/g, ''),
        cleanWord: baseVerb,
        trans: `${DICTIONARY_MAP[baseVerb].trans} (Acción en curso)`,
        pos: "Verbo (Gerundio)"
      };
    }
  }

  // 4. Fallback con Gemini API o traducción contextual si existe API key
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY || process.env.GEMINI_API_KEY;
  if (apiKey) {
    try {
      const res = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=${apiKey}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contents: [{
            parts: [{
              text: `Translate the English word "${cleanWord}" to Spanish in 1-3 words only, with word category (Verbo, Sustantivo, Adjetivo). Output format: "Traducción | Categoría"`
            }]
          }]
        })
      });
      if (res.ok) {
        const data = await res.json();
        const text = data.candidates?.[0]?.content?.parts?.[0]?.text?.trim();
        if (text && text.includes('|')) {
          const [trans, pos] = text.split('|').map(s => s.trim());
          return {
            word: cleanWord,
            cleanWord,
            trans,
            pos: pos || 'Vocabulario'
          };
        } else if (text) {
          return {
            word: cleanWord,
            cleanWord,
            trans: text,
            pos: 'Vocabulario'
          };
        }
      }
    } catch (e) {}
  }

  // Fallback por defecto si no está en la base
  return {
    word: cleanWord,
    cleanWord,
    trans: `Significado de "${cleanWord}" en contexto`,
    pos: "Vocabulario en inglés"
  };
}
